export default __webpack_public_path__ + "static/media/standard-logo.36f73dda.png";